import { utils, write } from 'xlsx';

export type Sheet = {
  name: string;
  rows: Record<string, string | number>[];
  headers?: string[];
};

const sanitizeSheetName = (name: string) =>
  name.replace(/[\\/?*[\]:]/g, ' ').slice(0, 31) || 'Sheet';

export const exportXlsx = (filename: string, sheets: Sheet[]) => {
  const wb = utils.book_new();
  const used = new Set<string>();
  for (const { name, rows, headers } of sheets) {
    let sheetName = sanitizeSheetName(name);
    let suffix = 2;
    while (used.has(sheetName)) {
      sheetName = sanitizeSheetName(`${name} ${suffix}`);
      suffix += 1;
    }
    used.add(sheetName);
    const ws = utils.json_to_sheet(rows, headers && { header: headers });
    utils.book_append_sheet(wb, ws, sheetName);
  }
  const buf = write(wb, { type: 'array', bookType: 'xlsx' });
  const blob = new Blob([buf], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
